export default __webpack_public_path__ + "styles/ItemToManyItemControl.03866573c7c75236a87a95879cd1f0f0.css";